import { Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { formatSweetSpotClass, formatSweetSpotDepth, formatSweetSpotScore } from './sweetSpotExport';
import type { GradeKey, SweetSpotPointResult } from './types';

type Props = { results: SweetSpotPointResult[]; height?: number };
type ResultTableRow = SweetSpotPointResult & { tableKey: string };

const GRADE_COLORS: Record<GradeKey, { label: string; color: string }> = {
  I: { label: 'Ⅰ级', color: 'green' },
  II: { label: 'Ⅱ级', color: 'blue' },
  III: { label: 'Ⅲ级', color: 'orange' },
  IV: { label: 'Ⅳ级', color: 'red' },
  V: { label: 'Ⅴ级', color: 'default' },
};

const columns: ColumnsType<ResultTableRow> = [
  { title: '测深 MD（m）', dataIndex: 'depth', width: 150, fixed: 'left', render: formatSweetSpotDepth },
  { title: '储层品质 RQ', dataIndex: 'rq', width: 160, render: formatSweetSpotScore },
  { title: '工程品质 CQ', dataIndex: 'cq', width: 160, render: formatSweetSpotScore },
  { title: '甜点指数 SSI', dataIndex: 'ssi', width: 190, render: formatSweetSpotScore },
  {
    title: '甜点等级', dataIndex: 'grade', width: 190,
    render: (grade: GradeKey | null) => grade
      ? <Tag color={GRADE_COLORS[grade].color}>{formatSweetSpotClass(grade)}</Tag>
      : '—',
  },
];

export default function SweetSpotResultTable({ results, height }: Props) {
  const validCount = results.filter((item) => item.ssi != null && item.grade != null).length;
  const rows: ResultTableRow[] = results.map((item, index) => ({
    ...item,
    tableKey: `${item.depth}-${index}`,
  }));
  return (
    <section className="sweetspot-results-table sweetspot-result-detail-view">
      <header className="sweetspot-result-detail-header">
          <strong>评价数据明细</strong>
          <span style={{ marginInlineStart: 8, color: '#71849A', fontSize: 11 }}>
            共 {results.length} 个深度点 · 有效 {validCount} 个
          </span>
      </header>
      <div className="sweetspot-table-shell">
          <Table<ResultTableRow>
            size="small"
            rowKey="tableKey"
            columns={columns}
            dataSource={rows}
            pagination={false}
            scroll={{ x: 870, y: height ? Math.max(180, height - 108) : 'min(38vh, 320px)' }}
            locale={{ emptyText: '尚无评价结果，请先执行评价' }}
          />
      </div>
    </section>
  );
}
